import { render } from "./EmpresaForm.vue?vue&type=template&id=33a7731f&scoped=true"
import script from "./EmpresaForm.vue?vue&type=script&lang=js"
export * from "./EmpresaForm.vue?vue&type=script&lang=js"

import "./EmpresaForm.vue?vue&type=style&index=0&id=33a7731f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a7731f"]])

export default __exports__